// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface CreateStreamEventsOut {}

export const CreateStreamEventsOutSerializer = {
  _fromJsonObject(_object: any): CreateStreamEventsOut {
    return {};
  },

  _toJsonObject(_self: CreateStreamEventsOut): any {
    return {};
  },
};
